import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_MentalHealthChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_MentalHealthChild' className='file-pdf-document'>
            <div className='file-template'>



                <table>
                    {/* <tr>
                        <td className='w-250'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Medicaid Number:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Client DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtClientDOB' name='txtClientDOB' className='add-only' /> </td>
                    </tr> */}

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Current Age:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCurrentAge' name='txtCurrentAge' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Gender:</span></td>
                        <td className='w-375'><span className='eleHeader'>Gender Orientation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='0' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='2' /> Female &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbGenderOrientation_Straight' name='rbGenderOrientation' className='add-only' value='0' /> Straight &nbsp;
                            <input type='radio' id='rbGenderOrientation_Lesbian' name='rbGenderOrientation' className='add-only' value='1' /> Lesbian &nbsp;
                            <input type='radio' id='rbGenderOrientation_Homosexual' name='rbGenderOrientation' className='add-only' value='1' /> Homosexual &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'><span className='eleHeader'>Gender Expression/Identity:</span></td>
                        <td className='w-250'><span className='eleHeader'>Primary Language:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='radio' id='rbGenderExpression_1' name='rbGenderExpression' className='add-only' value='1' /> Male </td>
                        <td className='w-125'><input type='radio' id='rbGenderExpression_2' name='rbGenderExpression' className='add-only' value='2' /> Female </td>
                        <td className='w-125'><input type='radio' id='rbGenderExpression_3' name='rbGenderExpression' className='add-only' value='3' /> Transgender </td>
                        <td className='w-125'><input type='radio' id='rbGenderExpression_4' name='rbGenderExpression' className='add-only' value='4' /> Homosexual </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Custodial Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='radio' id='rbCustodialStatus_Parent' name='rbCustodialStatus' className='add-only' value='0' /> Parent</td>
                        <td className='w-600'><input type='radio' id='rbCustodialStatus_Guardian' name='rbCustodialStatus' className='add-only' value='1' /> Guardian (Legal documents in record)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Marital Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbMaritalStatus' name='cbMaritalStatus' className='add-only' value='0' /> Minor </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Children:</b></td>
                        <td className='w-50'><input type='radio' id='rbMarital_Yes' name='rbMarital_1' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbMarital_No' name='rbMarital_1' className='add-only' value='1' /> No </td>
                        <td className='w-100'><b>How many?</b></td>
                        <td className='w-150'> <input type='text' id='txtHowmany' name='txtHowmany' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Race/Ethnicity</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEthnicity_1' name='cbEthnicity_1' className='add-only' value='Black/African American' /> Black/African American</td>
                        <td className='w-187'><input type='checkbox' id='cbEthnicity_2' name='cbEthnicity_2' className='add-only' value=' Hispanic or Latino' /> Hispanic or Latino </td>
                        <td className='w-187'><input type='checkbox' id='cbEthnicity_3' name='cbEthnicity_3' className='add-only' value=' White' /> White</td>
                        <td className='w-187'><input type='checkbox' id='cbEthnicity_4' name='cbEthnicity_4' className='add-only' value='Asian' /> Asian </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEthnicity_5' name='cbEthnicity_5' className='add-only' value=' American Indian or Alaskan Native' /> American Indian or Alaskan Native</td>
                        <td className='w-375'><input type='checkbox' id='cbEthnicity_6' name='cbEthnicity_6' className='add-only' value='Native Hawaiian or Other Pacific Islander' /> Native Hawaiian or Other Pacific Islander </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEthnicity_8' name='cbEthnicity_8' className='add-only' value='Two or more races:' /> Two or more races:
                            &nbsp;
                            <input type='text' id='txtEthnicity_8MoreRaces' name='txtEthnicity_8MoreRaces' className='add-only w-250 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEthnicity_7' name='cbEthnicity_7' className='add-only' value='Other (specify)' /> Other (specify):
                            &nbsp;
                            <input type='text' id='txtOther_1' name='txtOther_1' className='add-only w-250 custom-add-only' />
                        </td>

                    </tr>
                </table>
                <table>


                    <tr>
                        <td className='w-750'> <b> MHR PROGRAM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'> Date of Admission:</span></td>
                        <td className='w-250'><span className='eleHeader'> Re/Assessment Date:</span></td>
                        <td className='w-250'><span className='eleHeader'> LMHP:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateofAdmission' name='txtDateofAdmission' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtAssessmentDate' name='txtAssessmentDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLMHP' name='txtLMHP' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>  PRESENTING PROBLEM(S)</b>
                    <span className='small'>in recipient's own words</span>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>1. DESCRIBE MALADAPTIVE/PROBLEM BEHAVIORS:</span>
                    <textarea id='txtMALADAPTIVE' name='txtMALADAPTIVE' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 2. NATURE/FREQUENCY/EXTENT/SEVERITY/INTENSITY/DURATION:</span>
                    <textarea id='txtFREQUENCY' name='txtFREQUENCY' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>ATTEMPTED SOLUTIONS:</span>
                    <textarea id='txtSOLUTIONS' name='txtSOLUTIONS' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>
                        3. DESCRIBE EMOTIONAL STATE
                        <i>as reported by client, family members or other identified sources:</i>
                    </span>
                    <textarea id='txtEMOTIONAL' name='txtEMOTIONAL' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 4. DESCRIBE CLIENT'S PERCEPTION OF THE PROBLEM:</span>
                    <textarea id='txtPERCEPTION' name='txtPERCEPTION' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 5. DESCRIBE PREFERENCES FOR CARE:</span>
                    <textarea id='txtPREFERENCESFOR' name='txtPREFERENCESFOR' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b> LEVEL of FUNCTIONING</b>
                    <br />
                    <b> HOME</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>  1. DESCRIBE CURRENT EMOTIONAL and BEHAVIORAL FUNCTIONING in the home:</span>
                    <textarea id='txtDESCRIBECURRENT' name='txtDESCRIBECURRENT' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>  2. DESCRIBE LIVING SITUATION:</span>
                    <textarea id='txtDESCRIBELIVING' name='txtDESCRIBELIVING' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Environmental Surroundings:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEnvironmental_1' name='cbEnvironmental_1' className='add-only' value='Suburbs' /> Suburbs</td>
                        <td className='w-187'><input type='checkbox' id='cbEnvironmental_2' name='cbEnvironmental_2' className='add-only' value='City Living' /> City Living </td>
                        <td className='w-187'><input type='checkbox' id='cbEnvironmental_3' name='cbEnvironmental_3' className='add-only' value=' Gun Violence' /> Gun Violence</td>
                        <td className='w-187'><input type='checkbox' id='cbEnvironmental_4' name='cbEnvironmental_4' className='add-only' value='Known Drug Activity' /> Known Drug Activity </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEnvironmental_5' name='cbEnvironmental_5' className='add-only' value='Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_2' name='txtOther_2' className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>  3. DESCRIBE DAILY LIVING SKILLS:</span>
                    <textarea id='txtDAILYLIVING' name='txtDAILYLIVING' className='add-only'></textarea>

                    <span className='eleHeader'> 4. DESCRIBE ADAPTIVE BEHAVIORS and SKILLS </span>
                    <span className='small'>necessary to help client function day-to-day:</span>
                    <textarea id='txtADAPTIVEBEHAVIORS' name='txtADAPTIVEBEHAVIORS' className='add-only'></textarea>

                    <span className='eleHeader'>  5. DESCRIBE INTERESTS:</span>
                    <textarea id='txtDESCRIBEINTERESTS' name='txtDESCRIBEINTERESTS' className='add-only'></textarea>

                    <span className='eleHeader'>   6. DESCRIBE CHORES:</span>
                    <textarea id='txtDESCRIBECHORES' name='txtDESCRIBECHORES' className='add-only'></textarea>

                    <span className='eleHeader'>   7. DESCRIBE LEVEL OF PARTICIPATION </span>
                    <span className='small'>in the home:</span>
                    <textarea id='txtDESCRIBELEVEL' name='txtDESCRIBELEVEL' className='add-only'></textarea>

                    <b>  EDUCATION</b>

                    <span className='eleHeader'>  1. DESCRIBE CLIENT'S EDUCATIONAL BACKGROUND:</span>
                    <textarea id='txtEDUCATIONALBACKGROUND' name='txtEDUCATIONALBACKGROUND' className='add-only'></textarea>

                    <span className='eleHeader'>   2. DESCRIBE CLIENT'S PREFERRED AREA OF STUDY:</span>
                    <textarea id='txtPREFERREDAREA' name='txtPREFERREDAREA' className='add-only'></textarea>

                    <span className='eleHeader'>   3. DESCRIBE ATTITUDE TOWARDS ACADEMIC ACHIEVEMENT:</span>
                    <textarea id='txtATTITUDETOWARDS' name='txtATTITUDETOWARDS' className='add-only'></textarea>

                    <span className='eleHeader'>    4. DESCRIBE POSSIBILITIES FOR FUTURE EDCUATION:</span>
                    <textarea id='txtDESCRIBEPOSSIBILITIES' name='txtDESCRIBEPOSSIBILITIES' className='add-only'></textarea>

                    <b> TRAINING</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Does the client have any vocational training?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbvocational_Yes' name='rbvocational_1' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbvocational_No' name='rbvocational_1' className='add-only' value='1' /> No </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe.</span>
                    <textarea id='txtdescribe' name='txtdescribe' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>EMPLOYMENT</b></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Currently employed?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbCurrentlyemployed_Yes' name='rbCurrentlyemployed_1' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbCurrentlyemployed_No' name='rbCurrentlyemployed_1' className='add-only' value='1' /> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Work Experience:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtWorkExperience' name='txtWorkExperience' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Past Work Experience:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPastWorkExperience' name='txtPastWorkExperience' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Military Experience?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbMilitaryExperience_Yes' name='rbMilitaryExperience_1' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbMilitaryExperience_No' name='rbMilitaryExperience_1' className='add-only' value='1' /> No </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b> SOCIAL/COMMUNITY</b>

                    <span className='eleHeader'> 1. DESCRIBE SUPPORT SYSTEMS:</span>
                    <textarea id='txtSUPPORTSYSTEMS' name='txtSUPPORTSYSTEMS' className='add-only'></textarea>

                    <span className='eleHeader'> 2. DESCRIBE SOCIAL/PEER GROUPS and RELATIONS:</span>
                    <textarea id='txtPEERGROUPS' name='txtPEERGROUPS' className='add-only'></textarea>

                    <span className='eleHeader'>3. DESCRIBE CULTURAL/RACIAL/ETHNIC FACTORS:</span>
                    <textarea id='txtDESCRIBECULTURAL' name='txtDESCRIBECULTURAL' className='add-only'></textarea>

                    <span className='eleHeader'>4. DESCRIBE SPIRITUAL/RELIGIOUS ORIENTATION:</span>
                    <textarea id='txtSPIRITUAL' name='txtSPIRITUAL' className='add-only'></textarea>

                    <span className='eleHeader'>5. DESCRIBE SPECIAL TREATMENT APPROACHES NEEDED:</span>
                    <textarea id='txtAPPROACHESNEEDED' name='txtAPPROACHESNEEDED' className='add-only'></textarea>

                    <b>ACTIVITIES/INTERESTS</b>

                    <span className='eleHeader'>1. DESCRIBE RECREATIONAL and DAILY ACTIVITIES </span>
                    <span className='small'>including interests/hobbies/leisure</span>
                    <textarea id='txtRECREATIONAL' name='txtRECREATIONAL' className='add-only'></textarea>

                    <b> INTELLECTUAL/COGNITIVE FUNCTINING</b>

                    <span className='eleHeader'> 1. DESCRIBE ANY READING DIFFICULTIES:</span>
                    <textarea id='txtANYREADING' name='txtANYREADING' className='add-only'></textarea>


                    <span className='eleHeader'>2. DESCRIBE CONCEPTUAL ABILITIES </span>
                    <span className='small'>including concrete and abstract reasoning:</span>
                    <textarea id='txtDESCRIBEANY' name='txtDESCRIBEANY' className='add-only'></textarea>


                    <span className='eleHeader'> 3. DESCRIBE COMMUNICATION PROBLEMS:</span>
                    <textarea id='txtCOMMUNICATIONPROBLEMS' name='txtCOMMUNICATIONPROBLEMS' className='add-only'></textarea>


                    <span className='eleHeader'>4. DESCRIBE DEVELOPMENTAL DELAYS </span>
                    <span className='small'>including language barriers:</span>
                    <textarea id='txtDEVELOPMENTALDELAYS' name='txtDEVELOPMENTALDELAYS' className='add-only'></textarea>

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Is the client willing to participate in service/treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbclientwilling_Yes' name='rbclientwilling' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbclientwilling_No' name='rbclientwilling' className='add-only' value='1' /> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Is the client able to participate in service/treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbclientable_Yes' name='rbclient able' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbclientable_No' name='rbclient able' className='add-only' value='1' /> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is the parent/guardian willing to participate in service/treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbwillingtoparticipate_Yes' name='rbwillingtoparticipate' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbwillingtoparticipate_No' name='rbwillingtoparticipate' className='add-only' value='1' /> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is the parent/guardian able to participate in service/treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbabletoparticipate_Yes' name='rbabletoparticipate' className='add-only' value='0' /> Yes </td>
                        <td className='w-100'> <input type='radio' id='rbabletoparticipate_No' name='rbabletoparticipate' className='add-only' value='1' /> No </td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>MENTAL STATUS EVALUATION</b></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>ORIENTATION/ATTENTION/CONCENTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_1' name='cbDRESS_1' className='add-only' value=' Person' /> Person </td>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_2' name='cbDRESS_2' className='add-only' value=' Place' /> Place </td>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_3' name='cbDRESS_3' className='add-only' value=' Time' /> Time </td>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_4' name='cbDRESS_4' className='add-only' value=' Good' /> Good </td>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_5' name='cbDRESS_5' className='add-only' value='Distractible ' /> Distractible </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_6' name='cbORIENTATION_6' className='add-only' value=' Variable' /> Variable </td>
                        <td className='w-150'><input type='checkbox' id='cbORIENTATION_7' name='cbORIENTATION_7' className='add-only' value=' Not Assessed' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>GENERAL APPERANCES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_1' name='cbGENERALAPPERANCES_1' className='add-only' value='  Disheveled' /> Disheveled  </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_2' name='cbGENERALAPPERANCES_2' className='add-only' value=' Older than stated age' /> Older than stated age </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_3' name='cbGENERALAPPERANCES_3' className='add-only' value=' Younger than stated age' /> Younger than stated age </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_4' name='cbGENERALAPPERANCES_4' className='add-only' value=' Neat' /> Neat </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_5' name='cbGENERALAPPERANCES_5' className='add-only' value='Not Assessed ' /> Not Assessed </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_6' name='cbGENERALAPPERANCES_6' className='add-only' value=' Appropriate/ Normal' />  Appropriate/ Normal </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_7' name='cbGENERALAPPERANCES_7' className='add-only' value=' Emaciated' /> Emaciated </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_8' name='cbGENERALAPPERANCES_8' className='add-only' value=' Obese' /> Obese </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_9' name='cbGENERALAPPERANCES_9' className='add-only' value=' Neat' /> Neat </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCES_10' name='cbGENERALAPPERANCES_10' className='add-only' value='Poor Hygiene ' /> Poor Hygiene </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>FACIAL EXPRESSIONS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSIONS_1' name='cbFACIALEXPRESSIONS_1' className='add-only' value=' Avoids Gaze' /> Avoids Gaze </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSIONS_2' name='cbFACIALEXPRESSIONS_2' className='add-only' value=' Sad' /> Sad </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSIONS_3' name='cbFACIALEXPRESSIONS_3' className='add-only' value=' Worried' /> Worried </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSIONS_4' name='cbFACIALEXPRESSIONS_4' className='add-only' value=' Expressionless' /> Expressionless </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSIONS_5' name='cbFACIALEXPRESSIONS_5' className='add-only' value=' Hostile ' /> Hostile  </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbFACIALEXPRESSIONS_6' name='cbFACIALEXPRESSIONS_6' className='add-only' value=' Appropriate to topic ' /> Appropriate to topic  </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>DRESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_1' name='cbDRESS_1' className='add-only' value=' Age appropriate' /> Age appropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_2' name='cbDRESS_2' className='add-only' value=' Meticulous' /> Meticulous </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_3' name='cbDRESS_3' className='add-only' value=' Eccentric' /> Eccentric </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_4' name='cbDRESS_4' className='add-only' value=' Seductive' /> Seductive </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_5' name='cbDRESS_5' className='add-only' value=' Bizarre ' /> Bizarre </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbDRESS_6' name='cbDRESS_6' className='add-only' value='  Clothing/Hygiene Poor ' />  Clothing/Hygiene Poor </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> MOTOR ACTIVITY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_1' name='cbMOTORACTIVITY_1' className='add-only' value=' Normal' /> Normal </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_2' name='cbMOTORACTIVITY_2' className='add-only' value=' Unremarkable' /> Unremarkable </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_3' name='cbMOTORACTIVITY_3' className='add-only' value=' Increased amount' /> Increased amount </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_4' name='cbMOTORACTIVITY_4' className='add-only' value=' Decreased amount' /> Decreased amount </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_5' name='cbMOTORACTIVITY_5' className='add-only' value=' Repetitive acts ' /> Repetitive acts </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_6' name='cbMOTORACTIVITY_6' className='add-only' value=' Agitation' /> Agitation </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_7' name='cbMOTORACTIVITY_7' className='add-only' value=' Tics' /> Tics </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_8' name='cbMOTORACTIVITY_8' className='add-only' value=' Tremor' /> Tremor </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_9' name='cbMOTORACTIVITY_9' className='add-only' value=' Peculiar Posturing' /> Peculiar Posturing</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_10' name='cbMOTORACTIVITY_10' className='add-only' value=' Unusual Gait ' /> Unusual Gait </td>
                        <td className='w-250'><input type='checkbox' id='cbMOTORACTIVITY_12' name='cbMOTORACTIVITY_12' className='add-only' value=' Retardation' /> Retardation </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMOTORACTIVITY_11' name='cbMOTORACTIVITY_11' className='add-only' value=' Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_3' name='txtOther_3' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ATTITUDE/INTERVIEW BEHAVIOR</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_1' name='cbINTERVIEW_1' className='add-only' value=' Cooperative' /> Cooperative </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_2' name='cbINTERVIEW_2' className='add-only' value=' Uncooperative' /> Uncooperative </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_3' name='cbINTERVIEW_3' className='add-only' value=' Resistant' /> Resistant </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_4' name='cbINTERVIEW_4' className='add-only' value=' Suspicious' /> Suspicious </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_5' name='cbINTERVIEW_5' className='add-only' value=' Critical ' /> Critical </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_6' name='cbINTERVIEW_6' className='add-only' value=' Guarded' /> Guarded </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_7' name='cbINTERVIEW_7' className='add-only' value=' Hostile' /> Hostile </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_8' name='cbINTERVIEW_8' className='add-only' value=' Defensive' /> Defensive </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_9' name='cbINTERVIEW_9' className='add-only' value=' Passive' /> Passive </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_10' name='cbINTERVIEW_10' className='add-only' value=' Sarcastic ' /> Sarcastic </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_11' name='cbINTERVIEW_11' className='add-only' value=' Manipulative' /> Manipulative </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_12' name='cbINTERVIEW_12' className='add-only' value=' Irritable' /> Irritable </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_13' name='cbINTERVIEW_13' className='add-only' value=' Uninterested' /> Uninterested </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_14' name='cbINTERVIEW_14' className='add-only' value=' Silly' /> Silly </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_15' name='cbINTERVIEW_15' className='add-only' value=' Aggressive ' /> Aggressive </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_16' name='cbINTERVIEW_16' className='add-only' value=' Angry' /> Angry </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_17' name='cbINTERVIEW_17' className='add-only' value=' Argumentative' /> Argumentative </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_18' name='cbINTERVIEW_18' className='add-only' value=' Child-like' /> Child-like </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_19' name='cbINTERVIEW_19' className='add-only' value=' Demanding' /> Demanding </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_20' name='cbINTERVIEW_20' className='add-only' value=' Drastic ' /> Drastic </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_22' name='cbINTERVIEW_22' className='add-only' value=' Evasive' /> Evasive </td>
                        <td className='w-150'><input type='checkbox' id='cbINTERVIEW_23' name='cbINTERVIEW_23' className='add-only' value=' Withdrawn' /> Withdrawn </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbINTERVIEW_21' name='cbINTERVIEW_21' className='add-only' value=' Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_4' name='txtOther_4' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>SPEECH PATTERNS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_1' name='cbSPEECHPATTERNS_1' className='add-only' value=' Normal' /> Normal </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_2' name='cbSPEECHPATTERNS_2' className='add-only' value=' Excessive amount' /> Excessive amount </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_3' name='cbSPEECHPATTERNS_3' className='add-only' value=' Reduced amount' /> Reduced amount </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_4' name='cbSPEECHPATTERNS_4' className='add-only' value=' Pressured' /> Pressured </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_5' name='cbSPEECHPATTERNS_5' className='add-only' value=' Loud/Verbose ' /> Loud/Verbose </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_6' name='cbSPEECHPATTERNS_6' className='add-only' value=' Slowed' /> Slowed </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_7' name='cbSPEECHPATTERNS_7' className='add-only' value=' Monosyllable' /> Monosyllable</td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_8' name='cbSPEECHPATTERNS_8' className='add-only' value=' Stuttering' /> Stuttering</td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_9' name='cbSPEECHPATTERNS_9' className='add-only' value=' Hesitant' /> Hesitant </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_10' name='cbSPEECHPATTERNS_10' className='add-only' value=' Soft ' /> Soft </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECHPATTERNS_12' name='cbSPEECHPATTERNS_12' className='add-only' value=' Mute' /> Mute</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSPEECHPATTERNS_11' name='cbSPEECHPATTERNS_11' className='add-only' value=' Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_5' name='txtOther_5' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>MOOD</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_1' name='cbMOOD_1' className='add-only' value=' Euthymic' /> Euthymic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_2' name='cbMOOD_2' className='add-only' value=' Dysphoric' /> Dysphoric </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_3' name='cbMOOD_3' className='add-only' value=' Depressed' /> Depressed </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_4' name='cbMOOD_4' className='add-only' value=' Euphoric' /> Euphoric </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_5' name='cbMOOD_5' className='add-only' value=' Grandiose' /> Grandiose </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_6' name='cbMOOD_6' className='add-only' value=' Anxious ' /> Anxious </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_7' name='cbMOOD_7' className='add-only' value=' Labile' /> Labile </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_8' name='cbMOOD_8' className='add-only' value=' Irritable' /> Irritable </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_9' name='cbMOOD_9' className='add-only' value=' Angry' /> Angry </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_10' name='cbMOOD_10' className='add-only' value=' Not accessed' /> Not accessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>AFFECT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_1' name='cbAFFECT_1' className='add-only' value=' Congruent' /> Congruent </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_2' name='cbAFFECT_2' className='add-only' value=' Incongruent' /> Incongruent </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_3' name='cbAFFECT_3' className='add-only' value=' Appropriate' /> Appropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_4' name='cbAFFECT_4' className='add-only' value=' Inappropriate' /> Inappropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_5' name='cbAFFECT_5' className='add-only' value=' Broad' /> Broad </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_6' name='cbAFFECT_6' className='add-only' value=' Blunted ' /> Blunted </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_7' name='cbAFFECT_7' className='add-only' value=' Flat' /> Flat </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_8' name='cbAFFECT_8' className='add-only' value=' Labile' /> Labile </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_9' name='cbAFFECT_9' className='add-only' value=' Reactive' /> Reactive </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_10' name='cbAFFECT_10' className='add-only' value=' Constricted' /> Constricted </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>INSIGHT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_1' name='cbINSIGHT_1' className='add-only' value=' Excellent' /> Excellent </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_2' name='cbINSIGHT_2' className='add-only' value=' Good' /> Good </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_3' name='cbINSIGHT_3' className='add-only' value=' Poor' /> Poor </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_4' name='cbINSIGHT_4' className='add-only' value=' Fair' /> Fair </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_5' name='cbINSIGHT_5' className='add-only' value=' Nil' /> Nil </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_6' name='cbINSIGHT_6' className='add-only' value=' Not Assessed' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>JUDGMENT/IMPULSE CONTROL</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_1' name='cbJUDGMENT_1' className='add-only' value=' Excellent' /> Excellent </td>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_2' name='cbJUDGMENT_2' className='add-only' value=' Good' /> Good </td>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_3' name='cbJUDGMENT_3' className='add-only' value=' Fair' /> Fair </td>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_4' name='cbJUDGMENT_4' className='add-only' value=' Poor' /> Poor </td>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_5' name='cbJUDGMENT_5' className='add-only' value=' Nil' /> Nil </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbJUDGMENT_6' name='cbJUDGMENT_6' className='add-only' value=' Not Assessed' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>MEMORY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_1' name='cbMEMORY_1' className='add-only' value=' Intact' /> Intact </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_2' name='cbMEMORY_2' className='add-only' value=' Poor Remote' /> Poor Remote</td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_3' name='cbMEMORY_3' className='add-only' value=' Unimpaired' /> Unimpaired </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_4' name='cbMEMORY_4' className='add-only' value=' Poor' /> Poor </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_5' name='cbMEMORY_5' className='add-only' value=' Impaired long-term' /> Impaired long-term </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_6' name='cbMEMORY_6' className='add-only' value=' Impaired short-term' /> Impaired short-term </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_7' name='cbMEMORY_7' className='add-only' value=' Not Assessed ' /> Not Assessed  </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>THOUGHT PROCESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_1' name='cbTHOUGHTPROCESS_1' className='add-only' value=' Unremarkable' /> Unremarkable </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_2' name='cbTHOUGHTPROCESS_2' className='add-only' value=' Blocking' /> Blocking </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_3' name='cbTHOUGHTPROCESS_3' className='add-only' value=' Circumstantial' /> Circumstantial </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_4' name='cbTHOUGHTPROCESS_4' className='add-only' value=' Flight of ideas' /> Flight of ideas </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_5' name='cbTHOUGHTPROCESS_5' className='add-only' value=' Loose Associations' /> Loose Associations </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_6' name='cbTHOUGHTPROCESS_6' className='add-only' value=' Perseveration' /> Perseveration </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_7' name='cbTHOUGHTPROCESS_7' className='add-only' value=' Tangential' /> Tangential </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_8' name='cbTHOUGHTPROCESS_8' className='add-only' value=' Not Assessed' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>THOUGHT CONTENT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_1' name='cbTHOUGHTCONTENT_1' className='add-only' value=' Consistent with age' /> Consistent with age </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_2' name='cbTHOUGHTCONTENT_2' className='add-only' value=' Poverty of thought' /> Poverty of thought </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_3' name='cbTHOUGHTCONTENT_3' className='add-only' value='  Blames others' />  Blames others </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_4' name='cbTHOUGHTCONTENT_4' className='add-only' value=' Ideas of worthlessnesobias' /> Ideas of worthlessnesobias </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_5' name='cbTHOUGHTCONTENT_5' className='add-only' value=' Suicidal thoughts' /> Suicidal thoughts </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_6' name='cbTHOUGHTCONTENT_6' className='add-only' value=' Excessive religiosity' /> Excessive religiosity </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_7' name='cbTHOUGHTCONTENT_7' className='add-only' value=' Suicidal plans' /> Suicidal plans </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_8' name='cbTHOUGHTCONTENT_8' className='add-only' value=' Assaultive ideas' />  Assaultive ideas </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_9' name='cbTHOUGHTCONTENT_9' className='add-only' value=' Homicidal thoughts' /> Homicidal thoughts </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_10' name='cbTHOUGHTCONTENT_10' className='add-only' value=' Homicidal plans' /> Homicidal plans </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_11' name='cbTHOUGHTCONTENT_11' className='add-only' value=' Antisocial thoughts' /> Antisocial thoughts </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_12' name='cbTHOUGHTCONTENT_12' className='add-only' value=' Suspicious' /> Suspicious </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_13' name='cbTHOUGHTCONTENT_13' className='add-only' value=' Sexual preoccupation' />  Sexual preoccupation </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_14' name='cbTHOUGHTCONTENT_14' className='add-only' value='  Obsessions/compulsions' />  Obsessions/ compulsions </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_15' name='cbTHOUGHTCONTENT_15' className='add-only' value=' Feelings of unreality' /> Feelings of unreality </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_16' name='cbTHOUGHTCONTENT_16' className='add-only' value=' Preoccupied' /> Preoccupied </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_17' name='cbTHOUGHTCONTENT_17' className='add-only' value=' Phobias' /> Phobias </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_18' name='cbTHOUGHTCONTENT_18' className='add-only' value=' Thoughts of running away' />  Thoughts of running away </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_19' name='cbTHOUGHTCONTENT_19' className='add-only' value='  Somatic complaints' />  Somatic complaints </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_20' name='cbTHOUGHTCONTENT_20' className='add-only' value=' Ideas of guilt' /> Ideas of guilt </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_22' name='cbTHOUGHTCONTENT_22' className='add-only' value=' Ideas of hopelessness' /> Ideas of hopelessness </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTHOUGHTCONTENT_21' name='cbTHOUGHTCONTENT_21' className='add-only' value='Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_6' name='txtOther_6' className='add-only w-250 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>PERCEPTION/HALLUCINATIONS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_1' name='cbPERCEPTION_1' className='add-only' value=' Tactile' /> Tactile </td>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_2' name='cbPERCEPTION_2' className='add-only' value=' Auditory' /> Auditory </td>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_3' name='cbPERCEPTION_3' className='add-only' value='  Visual' />  Visual </td>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_4' name='cbPERCEPTION_4' className='add-only' value=' Command' /> Command </td>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_5' name='cbPERCEPTION_5' className='add-only' value=' Reported' /> Reported </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_6' name='cbPERCEPTION_6' className='add-only' value=' Gustatory' /> Gustatory </td>
                        <td className='w-150'><input type='checkbox' id='cbPERCEPTION_7' name='cbPERCEPTION_7' className='add-only' value=' Observed' /> Observed </td>
                        <td className='w-200'><input type='checkbox' id='cbPERCEPTION_8' name='cbPERCEPTION_8' className='add-only' value='  Unremarkable/ None' /> Unremarkable/ None </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> FUNCTIONAL STATUS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_1' name='cbFUNCTIONALSTATUS_1' className='add-only' value=' Intact' /> Intact </td>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_2' name='cbFUNCTIONALSTATUS_2' className='add-only' value=' Variably Impaired' /> Variably Impaired</td>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_3' name='cbFUNCTIONALSTATUS_3' className='add-only' value=' Mildly Impaired ' />  Mildly Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_4' name='cbFUNCTIONALSTATUS_4' className='add-only' value='Moderately Impaired' /> Moderately Impaired</td>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_5' name='cbFUNCTIONALSTATUS_5' className='add-only' value=' Severely Impaired' /> Severely Impaired </td>
                        <td className='w-187'><input type='checkbox' id='cbFUNCTIONALSTATUS_6' name='cbFUNCTIONALSTATUS_6' className='add-only' value=' Not Assessed' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> FUND of INFORMATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFUNDofINFORMATION_1' name='cbPERCEPTION_1' className='add-only' value=' Consistent of age' /> Consistent of age </td>
                        <td className='w-250'><input type='checkbox' id='cbFUNDofINFORMATION_2' name='cbPERCEPTION_2' className='add-only' value='   Poor historian' />   Poor historian </td>
                        <td className='w-250'><input type='checkbox' id='cbFUNDofINFORMATION_3' name='cbPERCEPTION_3' className='add-only' value=' Inconsistent with age' /> Inconsistent with age </td>


                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> DELUSIONS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbDELUSIONS_1' name='cbDELUSIONS_1' className='add-only' value=' None' />None </td>
                        <td className='w-150'><input type='checkbox' id='cbDELUSIONS_2' name='cbDELUSIONS_2' className='add-only' value=' of grandeur' /> of grandeur </td>
                        <td className='w-150'><input type='checkbox' id='cbDELUSIONS_3' name='cbDELUSIONS_3' className='add-only' value='   of persecution' />   of persecution </td>
                        <td className='w-150'><input type='checkbox' id='cbDELUSIONS_4' name='cbDELUSIONS_4' className='add-only' value='  of reference  ' />  of reference  </td>
                        <td className='w-150'><input type='checkbox' id='cbDELUSIONS_5' name='cbDELUSIONS_5' className='add-only' value=' Erotomaniac' /> Erotomaniac </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDELUSIONS_6' name='cbDELUSIONS_6' className='add-only' value=' Other:' />Other:
                            &nbsp;
                            <input type='text' id='txtOther_7' name='txtOther_7' className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>CLIENT'S PERSONAL HISTORY</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 1. DESCRIBE CLIENT'S GROWTH and DEVELOPMENT</span>
                    <span className='small'>(walking, talking, reading, counting, running, riding a bike)</span>
                    <textarea id='txtGROWTHand' name='txtGROWTHand' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. DESCRIBE CLIENT'S HISTORY of ABUSE/TRAUMA</span>
                    <span className='small'>( witnessed or experienced)</span>
                    <textarea id='txtHISTORYofABUSE' name='txtHISTORYofABUSE' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 3. DESCRIBE CLIENT'S HISTORY of EMOTIONAL and/or BEHAVIORAL PROBLEMS</span>
                    <span className='small'>(include history of mental illness and/or addictive behaviors)</span>
                    <textarea id='txtHISTORYofEMOTIONAL' name='txtHISTORYofEMOTIONAL' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b> FAMILY HISTORY</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 1. DESCRIBE FAMILY CIRCUMSTANCES</span>
                    <span className='small'>(past and present composition(birth order), family dynamic, family mental illness, abuse/neglect, substance use/abuse, other addictive behaviors)</span>
                    <textarea id='txtFAMILYCIRCUMSTANCES' name='txtFAMILYCIRCUMSTANCES' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. DESCRIBE FAMILY STRENGTHS, FINANCIAL RESOURCES, EXISTING SUPPORT SYSTEMS</span>
                    <textarea id='txtFAMILYSTRENGTHS' name='txtFAMILYSTRENGTHS' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. DESCRIBE FAMILY'S PERCEPTIONS and PREFERENCES FOR CARE, TREATMENT and SERVICES</span>
                    <textarea id='txtTREATMENTandSERVICES' name='txtTREATMENTandSERVICES' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. DESCRIBE RELATIONSHIP with FAMILY</span>

                    <b>a. Family of origin relationship?</b>
                    <textarea id='txtrelationship_1' name='txtrelationship_1' className='add-only'></textarea>
                    <br />
                    <b>b. Nuclear family relationship?</b>
                    <textarea id='txtrelationship_2' name='txtrelationship_2' className='add-only'></textarea>
                    <br />
                    <b>c. Significant other relationship?</b>
                    <textarea id='txtrelationship_3' name='txtrelationship_3' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <b>TREATMENT HISTORY</b> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>HISTORY of OUTPATIENT MENTAL HEALTH TREATMENT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHISTORYofOUTPATIENT_1' name='cbHISTORYofOUTPATIENT_1' className='add-only' value='NONE' /> NONE </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbHISTORYofOUTPATIENT_2' name='cbHISTORYofOUTPATIENT_2' className='add-only' value='PAST-' /> PAST-
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Diagnosis: </td>
                        <td className='w-375'>Provider: </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDiagnosis_1' name='txtDiagnosis_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtProvider_1' name='txtProvider_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbHISTORYofOUTPATIENT_3' name='cbHISTORYofOUTPATIENT_3' className='add-only' value='CURRENT-' /> CURRENT- </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Diagnosis: </td>
                        <td className='w-375'>Provider: </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDiagnosis_2' name='txtDiagnosis_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtProvider_2' name='txtProvider_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b> Please indicate the most recent Psychiatric Inpatient Hospitalizations </b></td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Hospital</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Admit Date/ Duration</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Reason</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtHospital_1' name='txtHospital_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtAdmitDate_1' name='txtAdmitDate_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtHospital_2' name='txtHospital_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtAdmitDate_2' name='txtAdmitDate_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>PAST BARRIERS TO TREATMENT:</span>
                    <textarea id='txtPASTBARRIERS' name='txtPASTBARRIERS' className='add-only'></textarea>
                    <b>CLIENT'S HISTORY of and/or CURRENT SUBSTANCE USE/ABUSE or DEPENDENCE</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>PRENATAL EXPOSURE to ALCOHOL, TOBACCO, or OTHER SUBSTANCES?</span>

                    <input type='checkbox' id='cbPRENATALEXPOSURE' name='cbPRENATALEXPOSURE' className='add-only' value='N/A' /> N/A  &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbPRENATALEXPOSURE_NO' name='rbPRENATALEXPOSURE' className='add-only' value='0' /> NO &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbPRENATALEXPOSURE_YES' name='rbPRENATALEXPOSURE' className='add-only' value='1' /> YES
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain</span>
                    <textarea id='txtPleaseexplain' name='txtPleaseexplain' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1. DESCRIBE HISTORY of ALCOHOL USE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbALCOHOLUSE' name='cbALCOHOLUSE' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Age of first use </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of last use </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Frequency </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Amount </span> </td>
                        <td className='w-300'> <span className='eleHeader'>Method of use </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtAgeoffirstuse_1' name='txtAgeoffirstuse_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateoflastuse_1' name='txtDateoflastuse_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAmount_1' name='txtAmount_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtMethodofuse_1' name='txtMethodofuse_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2. DESCRIBE HISTORY of DRUG USE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbDRUGUSE' name='cbDRUGUSE' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Age of first use </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of last use </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Frequency </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Amount </span> </td>
                        <td className='w-300'> <span className='eleHeader'>Method of use </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtAgeoffirstuse_2' name='txtAgeoffirstuse_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateoflastuse_2' name='txtDateoflastuse_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAmount_2' name='txtAmount_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtMethodofuse_2' name='txtMethodofuse_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>DESCRIBE HISTORY of NICOTINE USE or OTHER ADDICITIVE BEHAVIORS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbNICOTINEUSE' name='cbNICOTINEUSE' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Age of first use </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of last use </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Frequency </span> </td>
                        <td className='w-100'> <span className='eleHeader'>Amount </span> </td>
                        <td className='w-300'> <span className='eleHeader'>Method of use </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtAgeoffirstuse_3' name='txtAgeoffirstuse_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateoflastuse_3' name='txtDateoflastuse_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAmount_3' name='txtAmount_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtMethodofuse_3' name='txtMethodofuse_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Response to Previous Treatment:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbPreviousTreatment' name='cbPreviousTreatment' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtPreviousTreatment' name='txtPreviousTreatment' className='add-only'></textarea> </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Relapse History:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbRelapseHistory' name='cbRelapseHistory' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtRelapseHistory' name='txtRelapseHistory' className='add-only'></textarea>

                    <span className='eleHeader'>If history of substance abuse is inconclusive/unreliable:</span>
                    <textarea id='txtinconclusive' name='txtinconclusive' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Drug screen completed:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='radio' id='rbDrugscreen_NO' name='rbDrugscreen' className='add-only' value='0' /> NO </td>
                        <td className='w-50'><input type='radio' id='rbDrugscreen_YES' name='rbDrugscreen' className='add-only' value='1' /> YES </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>If yes - Results:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbyesResults_1' name='cbyesResults_1' className='add-only' value='Positive' /> Positive </td>
                        <td className='w-200'><input type='checkbox' id='cbyesResults_2' name='cbyesResults_2' className='add-only' value='Negative' /> Negative </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>MEDICAL INFORMATION</b> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Speech/Hearing/Visual</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbHearing_1' name='cbHearing_1' className='add-only' value='NORMAL' /> NORMAL </td>
                        <td className='w-200'><input type='checkbox' id='cbHearing_2' name='cbHearing_2' className='add-only' value='ABNORMAL' /> ABNORMAL </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Explain:</span>
                    <textarea id='txtExplain' name='txtExplain' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1. CURRENT ILLNESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbCURRENTILLNESS' name='cbCURRENTILLNESS' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtCURRENTILLNESS' name='txtCURRENTILLNESS' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2. PAST ILLNESSES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbPASTILLNESSES' name='cbPASTILLNESSES' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtPASTILLNESSES' name='txtPASTILLNESSES' className='add-only'></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>3. CLIENT'S GENERAL PHYSICAL HEALTH</span>
                    <span className='small'>(known symptoms or complaints)</span>
                    <textarea id='txtPHYSICALHEALTH' name='txtPHYSICALHEALTH' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>4. CURRENT/PAST INJURIES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbPASTINJURIES' name='cbPASTINJURIES' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtPASTINJURIES' name='txtPASTINJURIES' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5. CURRENT/PAST SURGERIES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbPASTSURGERIES' name='cbPASTSURGERIES' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtPASTSURGERIES' name='txtPASTSURGERIES' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5. CURRENT/PAST SURGERIES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbPASTSURGERIES' name='cbPASTSURGERIES' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtPASTSURGERIES' name='txtPASTSURGERIES' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>6. CURRENT/PAST MEDICAL HOSPITALIZATIONS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbMEDICALHOSPITALIZATIONS' name='cbMEDICALHOSPITALIZATIONS' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtMEDICALHOSPITALIZATIONS' name='txtMEDICALHOSPITALIZATIONS' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>7. CURRENT/PAST ALLERGIES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='checkbox' id='cbCURRENTALLERGIES' name='cbCURRENTALLERGIES' className='add-only' value='N/A' /> N/A </td>
                    </tr>
                </table>
                <p className='w-750'> <textarea id='txtCURRENTALLERGIES' name='txtCURRENTALLERGIES' className='add-only'></textarea></p>


                <p className='w-750'>
                    <span className='eleHeader'>8. ASSISTIVE DEVICES</span>
                    <input type='checkbox' id='cbASSISTIVE DEVICES' name='cbASSISTIVE' className='add-only' value='N/A' /> N/A &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbASSISTIVEDEVICES_NO' name='rbASSISTIVEDEVICES' className='add-only' value='0' /> NO &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbASSISTIVEDEVICES_YES' name='rbASSISTIVEDEVICES' className='add-only' value='1' /> YES
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>9. CURRENT/PAST NUTRIONAL STATUS</span>
                    <textarea id='txtPASTNUTRIONALSTATUS' name='txtPASTNUTRIONALSTATUS' className='add-only'></textarea>

                    <span className='eleHeader'>10. CURRENT/PAST NONPSYCHOTROPIC MEDICATIONS </span>
                    <span className='small'>(prescribed and over the counter)</span>
                    <textarea id='txtNONPSYCHOTROPIC' name='txtNONPSYCHOTROPIC' className='add-only'></textarea>

                    <span className='eleHeader'>ADVERSE REACTIONS TO MEDICATION</span>
                    <textarea id='txtREACTIONSTOMEDICATION' name='txtREACTIONSTOMEDICATION' className='add-only'></textarea> <br />

                    <b>LAST PHYSICAL EXAMINATION</b>
                </p>

                <table>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'>Physician's Name & Address</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone<i>(if known)</i></span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtPhysiciansName' name='txtPhysiciansName' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Any significant findings/follow-up needed:</span>
                    <textarea id='txtsignificantfindings' name='txtsignificantfindings' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Are Immunizations current?</span>
                </p>
                <p className='w-750'>
                    <b>Record reviewed</b> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbAreImmunizationsCurrentRecordReviewed_YES' name='rbAreImmunizationsCurrentRecordReviewed' className='add-only' value='1' /> YES &nbsp;&nbsp;
                    <input type='radio' id='rbAreImmunizationsCurrentRecordReviewed_NO' name='rbAreImmunizationsCurrentRecordReviewed' className='add-only' value='0' /> NO
                </p>
                <p className='w-750'>
                    <b>Verbally stated current</b>&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbAreImmunizationsCurrentVerbally_YES' name='rbAreImmunizationsCurrentVerbally' className='add-only' value='1' /> YES &nbsp;&nbsp;
                    <input type='radio' id='rbAreImmunizationsCurrentVerbally_NO' name='rbAreImmunizationsCurrentVerbally' className='add-only' value='0' /> NO
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Needed Medical Attention:</span>
                    <span className='small'>List if the client received a physical examination or appropriate referral within 72 hours if indicated by physician, nursing assessment or screening:</span>
                    <textarea id='txtNeededMedical' name='txtNeededMedical' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Physical Examination:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='radio' id='rbPhysicalExamination_NO' name='rbPhysicalExamination' className='add-only' value='0' /> NO </td>
                        <td className='w-50'><input type='radio' id='rbPhysicalExamination_YES' name='rbPhysicalExamination' className='add-only' value='1' /> YES </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Referral: Is the referral completed within 72 hours?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='radio' id='rbreferralcompleted_NO' name='rbreferralcompleted' className='add-only' value='0' /> NO </td>
                        <td className='w-50'><input type='radio' id='rbreferralcompleted_YES' name='rbreferralcompleted' className='add-only' value='1' /> YES </td>
                    </tr>

                    <tr>
                        <td className='w-500'><span className='eleHeader'>Referral Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtReferralName' name='txtReferralName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>PSYCHOTROPIC MEDICATION:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>(Describe current and past psychotropic medication, including medication type, reason prescribed, dosage, prescribing physician, and start/stop date if applicable. Also comment on any known side effects from medication and the client's compliance with prescribed medications)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Date of last Psychiatric Evaluation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtlastPsychiatric' name='txtlastPsychiatric' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Current Psychotropic Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbCurrentPsychotropicMedication_NO' name='rbCurrentPsychotropicMedication' className='add-only' value='0' /> NONE </td>
                        <td className='w-50'><input type='radio' id='rbCurrentPsychotropicMedication_YES' name='rbCurrentPsychotropicMedication' className='add-only' value='1' /> YES </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Past Psychotropic Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbPastPsychotropicMedication_NO' name='rbPastPsychotropicMedication' className='add-only' value='0' /> NONE </td>
                        <td className='w-50'><input type='radio' id='rbPastPsychotropicMedication_YES' name='rbPastPsychotropicMedication' className='add-only' value='1' /> YES </td>
                    </tr>

                </table>






                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe below:</span>
                    <textarea id='txtIfYesplease' name='txtIfYesplease' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1. Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> Dosage</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Method</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Purpose</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Current/Past</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Compliance</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtMethod_1' name='txtMethod_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPurpose_1' name='txtPurpose_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrentPast_1' name='txtCurrentPast_1' className='add-only' /> </td>
                        <td className='w-100'> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2. Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> Dosage</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Method</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Purpose</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Current/Past</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Compliance</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtMethod_2' name='txtMethod_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPurpose_2' name='txtPurpose_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrentPast_2' name='txtCurrentPast_2' className='add-only' /> </td>
                        <td className='w-100'> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>3. Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> Dosage</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Method</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Purpose</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Current/Past</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Compliance</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtMethod_3' name='txtMethod_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPurpose_3' name='txtPurpose_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrentPast_3' name='txtCurrentPast_3' className='add-only' /> </td>
                        <td className='w-100'> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>4. Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> Dosage</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Method</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Purpose</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Current/Past</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Compliance</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtMethod_4' name='txtMethod_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPurpose_4' name='txtPurpose_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrentPast_4' name='txtCurrentPast_4' className='add-only' /> </td>
                        <td className='w-100'> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5. Medication</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> Dosage</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Method</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Purpose</span> </td>
                        <td className='w-150'> <span className='eleHeader'> Current/Past</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Compliance</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtMethod_5' name='txtMethod_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPurpose_5' name='txtPurpose_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrentPast_5' name='txtCurrentPast_5' className='add-only' /> </td>
                        <td className='w-100'> No </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Medication Effectiveness:</span>
                    <textarea id='txtMedicationEffectiveness' name='txtMedicationEffectiveness' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medication Side Effects:</span>
                    <textarea id='txtMedicationSideEffects' name='txtMedicationSideEffects' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal/Criminal History:</span>
                    <span className='small'> (Describe any legal issues and client's legal status, including criminal involvement, arrests, adjudications, probation/parole involvement, and DCFS involvement. Identify client's legal guardian and permanency goal, if applicable. Describe any court involvement)</span>
                    <textarea id='txtLegalCriminalHistory' name='txtLegalCriminalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Assessment of Safety/Risk:</span>
                    <span className='small'>  (Describe any current and immediate threat to the client and/or family or posed by the client, in regard to gang affiliation/involvement, domestic violence, fire setting, physical aggression, sexual abuse, elder/child abuse, etc.)</span>
                </p>


                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_1' name='cbAssessmentofSafety_1' className='add-only' value='Current Ideations' /> Current Ideations </td>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_2' name='cbAssessmentofSafety_2' className='add-only' value='Access to means' /> Access to means </td>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_3' name='cbAssessmentofSafety_3' className='add-only' value='History of attempts/behaviors' /> History of attempts/ behaviors </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_4' name='cbAssessmentofSafety_4' className='add-only' value='Alcohol/Substance use' /> Alcohol/Substance use </td>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_5' name='cbAssessmentofSafety_5' className='add-only' value='Impulsivity' /> Impulsivity </td>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_6' name='cbAssessmentofSafety_6' className='add-only' value='Hopelessness' /> Hopelessness </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_7' name='cbAssessmentofSafety_7' className='add-only' value='Recent loss' /> Recent loss </td>
                        <td className='w-250'><input type='checkbox' id='cbAssessmentofSafety_8' name='cbAssessmentofSafety_8' className='add-only' value='Family history' /> Family history </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id='txtDescribe_1' name='txtDescribe_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Risk of Harm to Self:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoSelf_1' name='cbRiskofHarmtoSelf_1' className='add-only' value='No History/Evidence' /> No History/Evidence </td>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoSelf_2' name='cbRiskofHarmtoSelf_2' className='add-only' value='History/Evidence' /> History/Evidence </td>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoSelf_3' name='cbRiskofHarmtoSelf_3' className='add-only' value='Current Threat' /> Current Threat </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id='txtDescribe_2' name='txtDescribe_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Risk of Harm to Others:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoOthers_1' name='cbRiskofHarmtoOthers_1' className='add-only' value='No History/Evidence' /> No History/Evidence </td>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoOthers_2' name='cbRiskofHarmtoOthers_2' className='add-only' value='History/Evidence' /> History/Evidence </td>
                        <td className='w-250'><input type='checkbox' id='cbRiskofHarmtoOthers_3' name='cbRiskofHarmtoOthers_3' className='add-only' value='Current Threat' /> Current Threat </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id='txtDescribe_3' name='txtDescribe_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Protective Factors:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_1' name='cbProtectiveFactors_1' className='add-only' value='Positive social support' /> Positive social support </td>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_2' name='cbProtectiveFactors_2' className='add-only' value='Cultural/Religious beliefs' /> Cultural/Religious beliefs </td>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_3' name='cbProtectiveFactors_3' className='add-only' value='Social responsibility' /> Social responsibility </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_4' name='cbProtectiveFactors_4' className='add-only' value='Children in the home' /> Children in the home </td>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_5' name='cbProtectiveFactors_5' className='add-only' value='Life satisfaction' /> Life satisfaction </td>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_6' name='cbProtectiveFactors_6' className='add-only' value='Positive coping skills' /> Positive coping skills </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_7' name='cbProtectiveFactors_7' className='add-only' value='Sufficient problemsolving skills' /> Sufficient problemsolving skills </td>
                        <td className='w-250'><input type='checkbox' id='cbProtectiveFactors_8' name='cbProtectiveFactors_8' className='add-only' value='Strong therapeutic rapport' /> Strong therapeutic rapport </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id='txtDescribe_4' name='txtDescribe_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>CLIENT STRENGTHS - <i>Character Traits</i></span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_1' name='cbCLIENTSTRENGTHS_1' className='add-only' value='Adventurous' /> Adventurous </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_2' name='cbCLIENTSTRENGTHS_2' className='add-only' value='Assertive' /> Assertive </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_3' name='cbCLIENTSTRENGTHS_3' className='add-only' value='Caring' /> Caring </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_4' name='cbCLIENTSTRENGTHS_4' className='add-only' value='Compassionate' /> Compassionate </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_5' name='cbCLIENTSTRENGTHS_5' className='add-only' value='Confident' /> Confident </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_6' name='cbCLIENTSTRENGTHS_6' className='add-only' value='Considerate' /> Considerate </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_7' name='cbCLIENTSTRENGTHS_7' className='add-only' value='Creative' /> Creative </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_8' name='cbCLIENTSTRENGTHS_8' className='add-only' value='Curious' /> Curious </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_9' name='cbCLIENTSTRENGTHS_9' className='add-only' value='Determined' /> Determined </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_10' name='cbCLIENTSTRENGTHS_10' className='add-only' value='Empathic' /> Empathic </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_11' name='cbCLIENTSTRENGTHS_11' className='add-only' value='Friendly' /> Friendly </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_12' name='cbCLIENTSTRENGTHS_12' className='add-only' value='Generous' /> Generous </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_13' name='cbCLIENTSTRENGTHS_13' className='add-only' value='Goal-Oriented' /> Goal-Oriented </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_14' name='cbCLIENTSTRENGTHS_14' className='add-only' value='Helpful' /> Helpful </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_15' name='cbCLIENTSTRENGTHS_15' className='add-only' value='Honest' /> Honest </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_16' name='cbCLIENTSTRENGTHS_16' className='add-only' value='Humorous' /> Humorous </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_17' name='cbCLIENTSTRENGTHS_17' className='add-only' value='Independent' /> Independent</td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_18' name='cbCLIENTSTRENGTHS_18' className='add-only' value='Inquisitive' /> Inquisitive </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_19' name='cbCLIENTSTRENGTHS_19' className='add-only' value='Insightful' /> Insightful </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_20' name='cbCLIENTSTRENGTHS_20' className='add-only' value='Kind' /> Kind </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_21' name='cbCLIENTSTRENGTHS_21' className='add-only' value='Optimistic' /> Optimistic</td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_22' name='cbCLIENTSTRENGTHS_22' className='add-only' value='Outgoing' /> Outgoing </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_23' name='cbCLIENTSTRENGTHS_23' className='add-only' value='Patient' /> Patient </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_24' name='cbCLIENTSTRENGTHS_24' className='add-only' value='Preserving' /> Preserving </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_25' name='cbCLIENTSTRENGTHS_25' className='add-only' value='Pleasant' /> Pleasant</td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_26' name='cbCLIENTSTRENGTHS_26' className='add-only' value='Polite' /> Polite </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_27' name='cbCLIENTSTRENGTHS_27' className='add-only' value='Reliable' /> Reliable </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_28' name='cbCLIENTSTRENGTHS_28' className='add-only' value='Resourceful' /> Resourceful </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_29' name='cbCLIENTSTRENGTHS_29' className='add-only' value='Respectful' /> Respectful</td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_30' name='cbCLIENTSTRENGTHS_30' className='add-only' value='Responsible' /> Responsible </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_31' name='cbCLIENTSTRENGTHS_31' className='add-only' value='Social' /> Social </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_32' name='cbCLIENTSTRENGTHS_32' className='add-only' value='Spiritual' /> Spiritual </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_33' name='cbCLIENTSTRENGTHS_33' className='add-only' value='Thoughtful' /> Thoughtful</td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_34' name='cbCLIENTSTRENGTHS_34' className='add-only' value='Tolerant' /> Tolerant </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_35' name='cbCLIENTSTRENGTHS_35' className='add-only' value='Trustworthy' /> Trustworthy </td>
                        <td className='w-187'><input type='checkbox' id='cbCLIENTSTRENGTHS_36' name='cbCLIENTSTRENGTHS_36' className='add-only' value='Understanding' /> Understanding </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCLIENTSTRENGTHS_37' name='cbCLIENTSTRENGTHS_37' className='add-only' value='Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_8' name='txtOther_8' className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>CLIENT WEAKNESSES/NEEDS</b></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id='txtDescribe_5' name='txtDescribe_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>CLIENT SKILLS/ABILITIES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_1' name='cbCLIENTABILITIES_1' className='add-only' value='Writer (journal, poetry)' /> Writer (journal, poetry) </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_2' name='cbCLIENTABILITIES_2' className='add-only' value='Academically successful' /> Academically successful </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_3' name='cbCLIENTABILITIES_3' className='add-only' value='Anger management skills' /> Anger management skills </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_4' name='cbCLIENTABILITIES_4' className='add-only' value='Artistic' /> Artistic</td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_5' name='cbCLIENTABILITIES_5' className='add-only' value='Asks for help' /> Asks for help </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_6' name='cbCLIENTABILITIES_6' className='add-only' value='Athletic' />Athletic </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_7' name='cbCLIENTABILITIES_7' className='add-only' value='Follows directions' /> Follows directions </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_8' name='cbCLIENTABILITIES_8' className='add-only' value='Gets along well with others' /> Gets along well with others </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_9' name='cbCLIENTABILITIES_9' className='add-only' value='Has/uses good manners' /> Has/uses good manners </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_10' name='cbCLIENTABILITIES_10' className='add-only' value='Healthy coping skills' /> Healthy coping skills</td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_11' name='cbCLIENTABILITIES_11' className='add-only' value='Musical ability' /> Musical ability </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_12' name='cbCLIENTABILITIES_12' className='add-only' value='Organization' /> Organization </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_13' name='cbCLIENTABILITIES_13' className='add-only' value='Respects others belongings' /> Respects other's belongings </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_14' name='cbCLIENTABILITIES_14' className='add-only' value='Shares feelings with others' /> Shares feelings with others </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_15' name='cbCLIENTABILITIES_15' className='add-only' value='Shares problems with others' /> Shares problems with others </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_16' name='cbCLIENTABILITIES_16' className='add-only' value='Shows appreciation to others' /> Shows appreciation to others</td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_17' name='cbCLIENTABILITIES_17' className='add-only' value='Social skills' /> Social skills </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_18' name='cbCLIENTABILITIES_18' className='add-only' value='Study skills' /> Study skills </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_19' name='cbCLIENTABILITIES_19' className='add-only' value='Has/utilizes a support system' /> Has/utilizes a support system</td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_20' name='cbCLIENTABILITIES_20' className='add-only' value='Verbally communicative' /> Verbally communicative </td>
                        <td className='w-250'><input type='checkbox' id='cbCLIENTABILITIES_21' name='cbCLIENTABILITIES_21' className='add-only' value='Willing to try new things' /> Willing to try new things </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input type='checkbox' id='cbCLIENTABILITIES_23' name='cbCLIENTABILITIES_23' className='add-only' value='Ability to make/maintain friendships' /> Ability to make/maintain friendships </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCLIENTABILITIES_22' name='cbCLIENTABILITIES_22' className='add-only' value='Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_9' name='txtOther_9' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>OTHER INTERESTS/ACTIVITIES/PREFERENCES</span>
                    <textarea id='txtINTERESTSACTIVITIES' name='txtINTERESTSACTIVITIES' className='add-only'></textarea>

                    <span className='eleHeader'>GENERAL CLINICAL SUMMARY</span>
                    <span className='small'>
                        (Describe your diagnosis, symptoms that support the diagnosis, and how the client's functioning is impaired. Describe any functional problems.
                        Comment on the client's preference for services and how his/her functioning is affected by this. Include your source of information, if applicable and
                        summarize client's presentation and significant mental status findings. Note client's strengths and effectiveness of coping skills and assessment of
                        the individual relative to normative development for his/her chronological age. Evaluate client's current level of support and how it affects stability.
                        When addressing bereavement, the social, spiritual and cultural variables that influence the perceptions and expressions of grief by the client or
                        family are addressed. Provide statements regarding the DSM-V diagnosis and CA/LOCUS score you are assigning. Identify potential barriers to
                        treatment and any resultant special treatment approaches.)
                    </span>
                    <textarea id='txtGENERALCLINICALSUMMARY' name='txtGENERALCLINICALSUMMARY' className='add-only' rows={10}></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Supporting DSM-V Criteria</span> </td>
                        <td className='w-150'> <span className='eleHeader'>CA/LOCUS Score</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_1' name='txtSupportingDsm_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_1' name='txtCaLocus_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_2' name='txtSupportingDsm_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_2' name='txtCaLocus_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_3' name='txtSupportingDsm_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_3' name='txtCaLocus_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_4' name='txtSupportingDsm_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_4' name='txtCaLocus_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_5' name='txtSupportingDsm_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_5' name='txtCaLocus_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSupportingDsm_6' name='txtSupportingDsm_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCaLocus_6' name='txtCaLocus_6' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>

                    <b>DIAGNOSIS</b>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Primary:</span>
                    <textarea id='txtPrimary' name='txtPrimary' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Secondary:</span>
                    <textarea id='txtSecondary' name='txtSecondary' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Tertiary:</span>
                    <textarea id='txtTertiary' name='txtTertiary' className='add-only'></textarea>
                </p>

                <table>
                    <td className='w-500'></td>
                </table>

                <p className='w-750'>
                    <b><b>Include main problems related to the mental health diagnosis (symptoms, functional impairments, problems related to risk and safety) and any other issues identified as significant in the assessment.</b></b>

                    <span className='eleHeader'>1.Identified Problems</span>
                    <span className='small'>(List according to priority)</span>
                    <textarea id='txtIdentifiedProblems_1' name='txtIdentifiedProblems_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1.Severity Rating</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Circle one)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_1' name='rbRating_1' className='add-only' value='0' /> 1 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_2' name='rbRating_1' className='add-only' value='1' /> 2 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_3' name='rbRating_1' className='add-only' value='2' /> 3 </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1.Recommendation/Interventions/Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_1' name='cbInterventions_1' className='add-only' value='Medication Management' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_2' name='cbInterventions_2' className='add-only' value='Integrated Healthcare (PCP/Medical)' /> Integrated Healthcare (PCP/Medical) </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_3' name='cbInterventions_3' className='add-only' value='Peer Support' /> Peer Support </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_4' name='cbInterventions_4' className='add-only' value='Group Support' /> Group Support </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_5' name='cbInterventions_5' className='add-only' value='Community Psychiatric Support & Treatment' /> Community Psychiatric Support & Treatment </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_6' name='cbInterventions_6' className='add-only' value='Psychological Rehabilitation' /> Psychological Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_7' name='cbInterventions_7' className='add-only' value='Housing Assistance' /> Housing Assistance </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_8' name='cbInterventions_8' className='add-only' value='Vocational Assistance' /> Vocational Assistance </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_9' name='cbInterventions_9' className='add-only' value='Family Psychoeducation' /> Family Psychoeducation </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_10' name='cbInterventions_10' className='add-only' value='Individual Counseling' /> Individual Counseling </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>2.Identified Problems</span>
                    <span className='small'>(List according to priority)</span>
                    <textarea id='txtIdentifiedProblems_2' name='txtIdentifiedProblems_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2.Severity Rating</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Circle one)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_4' name='rbRating_2' className='add-only' value='0' /> 1 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_5' name='rbRating_2' className='add-only' value='1' /> 2 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_6' name='rbRating_2' className='add-only' value='2' /> 3 </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2.Recommendation/Interventions/Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_11' name='cbInterventions_11' className='add-only' value='Medication Management' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_12' name='cbInterventions_12' className='add-only' value='Integrated Healthcare (PCP/Medical)' /> Integrated Healthcare (PCP/Medical) </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_13' name='cbInterventions_13' className='add-only' value='Peer Support' /> Peer Support </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_14' name='cbInterventions_14' className='add-only' value='Group Support' /> Group Support </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_15' name='cbInterventions_15' className='add-only' value='Community Psychiatric Support & Treatment' /> Community Psychiatric Support & Treatment </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_16' name='cbInterventions_16' className='add-only' value='Psychological Rehabilitation' /> Psychological Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_17' name='cbInterventions_17' className='add-only' value='Housing Assistance' /> Housing Assistance </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_18' name='cbInterventions_18' className='add-only' value='Vocational Assistance' /> Vocational Assistance </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_19' name='cbInterventions_19' className='add-only' value='Family Psychoeducation' /> Family Psychoeducation </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_20' name='cbInterventions_20' className='add-only' value='Individual Counseling' /> Individual Counseling </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>3.Identified Problems</span>
                    <span className='small'>(List according to priority)</span>
                    <textarea id='txtIdentifiedProblems_3' name='txtIdentifiedProblems_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>3.Severity Rating</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Circle one)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_7' name='rbRating_3' className='add-only' value='0' /> 1 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_8' name='rbRating_3' className='add-only' value='1' /> 2 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_9' name='rbRating_3' className='add-only' value='2' /> 3 </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>3.Recommendation/Interventions/Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_21' name='cbInterventions_21' className='add-only' value='Medication Management' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_22' name='cbInterventions_22' className='add-only' value='Integrated Healthcare (PCP/Medical)' /> Integrated Healthcare (PCP/Medical) </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_23' name='cbInterventions_23' className='add-only' value='Peer Support' /> Peer Support </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_24' name='cbInterventions_24' className='add-only' value='Group Support' /> Group Support </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_25' name='cbInterventions_25' className='add-only' value='Community Psychiatric Support & Treatment' /> Community Psychiatric Support & Treatment </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_26' name='cbInterventions_26' className='add-only' value='Psychological Rehabilitation' /> Psychological Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_27' name='cbInterventions_27' className='add-only' value='Housing Assistance' /> Housing Assistance </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_28' name='cbInterventions_28' className='add-only' value='Vocational Assistance' /> Vocational Assistance </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_29' name='cbInterventions_29' className='add-only' value='Family Psychoeducation' /> Family Psychoeducation </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_30' name='cbInterventions_30' className='add-only' value='Individual Counseling' /> Individual Counseling </td>
                    </tr>
                </table>

                <p className='w-750'>

                    <span className='eleHeader'>4.Identified Problems</span>
                    <span className='small'>(List according to priority)</span>
                    <textarea id='txtIdentifiedProblems_4' name='txtIdentifiedProblems_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>4.Severity Rating</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Circle one)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_10' name='rbRating_4' className='add-only' value='0' /> 1 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_11' name='rbRating_4' className='add-only' value='1' /> 2 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_12' name='rbRating_4' className='add-only' value='2' /> 3 </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>4.Recommendation/Interventions/Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_31' name='cbInterventions_31' className='add-only' value='Medication Management' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_32' name='cbInterventions_32' className='add-only' value='Integrated Healthcare (PCP/Medical)' /> Integrated Healthcare (PCP/Medical) </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_33' name='cbInterventions_33' className='add-only' value='Peer Support' /> Peer Support </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_34' name='cbInterventions_34' className='add-only' value='Group Support' /> Group Support </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_35' name='cbInterventions_35' className='add-only' value='Community Psychiatric Support & Treatment' /> Community Psychiatric Support & Treatment </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_36' name='cbInterventions_36' className='add-only' value='Psychological Rehabilitation' /> Psychological Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_37' name='cbInterventions_37' className='add-only' value='Housing Assistance' /> Housing Assistance </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_38' name='cbInterventions_38' className='add-only' value='Vocational Assistance' /> Vocational Assistance </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_39' name='cbInterventions_39' className='add-only' value='Family Psychoeducation' /> Family Psychoeducation </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_40' name='cbInterventions_40' className='add-only' value='Individual Counseling' /> Individual Counseling </td>
                    </tr>
                </table>

                <p className='w-750'>

                    <span className='eleHeader'>5.Identified Problems</span>
                    <span className='small'>(List according to priority)</span>
                    <textarea id='txtIdentifiedProblems_5' name='txtIdentifiedProblems_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5.Severity Rating</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Circle one)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_13' name='rbRating_5' className='add-only' value='0' /> 1 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_14' name='rbRating_5' className='add-only' value='1' /> 2 </td>
                        <td className='w-100'> <input type='radio' id='rbSeverityRating_15' name='rbRating_5' className='add-only' value='2' /> 3 </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5.Recommendation/Interventions/Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_41' name='cbInterventions_41' className='add-only' value='Medication Management' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_42' name='cbInterventions_42' className='add-only' value='Integrated Healthcare (PCP/Medical)' /> Integrated Healthcare (PCP/Medical) </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_43' name='cbInterventions_43' className='add-only' value='Peer Support' /> Peer Support </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_44' name='cbInterventions_44' className='add-only' value='Group Support' /> Group Support </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_45' name='cbInterventions_45' className='add-only' value='Community Psychiatric Support & Treatment' /> Community Psychiatric Support & Treatment </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_46' name='cbInterventions_46' className='add-only' value='Psychological Rehabilitation' /> Psychological Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_47' name='cbInterventions_47' className='add-only' value='Housing Assistance' /> Housing Assistance </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_48' name='cbInterventions_48' className='add-only' value='Vocational Assistance' /> Vocational Assistance </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_49' name='cbInterventions_49' className='add-only' value='Family Psychoeducation' /> Family Psychoeducation </td>
                        <td className='w-375'><input type='checkbox' id='cbInterventions_50' name='cbInterventions_50' className='add-only' value='Individual Counseling' /> Individual Counseling </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>FURTHER EVALUATIONS NEEDED</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(Check all that apply)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_1' name='cbEVALUATIONS_1' className='add-only' value='None Indicated' /> None Indicated </td>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_2' name='cbEVALUATIONS_2' className='add-only' value='Psychiatric' /> Psychiatric </td>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_3' name='cbEVALUATIONS_3' className='add-only' value='Substance Abuse' /> Substance Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_4' name='cbEVALUATIONS_4' className='add-only' value='Housing' /> Housing</td>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_5' name='cbEVALUATIONS_5' className='add-only' value='Vocational' /> Vocational</td>
                        <td className='w-250'><input type='checkbox' id='cbEVALUATIONS_6' name='cbEVALUATIONS_6' className='add-only' value='PCP/Medical' /> PCP/Medical</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b>REFERRALS</b> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(List referrals to appropriate services based on level of care)</span> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Referral Name</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Address</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtReferral_1' name='txtReferral_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNo_1' name='txtPhoneNo_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtReferral_2' name='txtReferral_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNo_2' name='txtPhoneNo_2' className='add-only' /> </td>
                    </tr>
                </table> 





            </div>
        </form >

    )
}